module.exports = __webpack_public_path__ + "img/40.eab6e290.png";